import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["uploadButton", "fileInput", "preview", "previewPlaceholder", "trash", "hiddenInputDestroy"]

  openFile(e) {
    e.preventDefault()
    this.fileInputTarget.click()
  }

  preview(e) {
    let file = this.fileInputTarget.files[0]
    let fileReader = new FileReader()

    fileReader.onloadend = () => {
      if (this.hasHiddenInputDestroyTarget) this.hiddenInputDestroyTarget.value = "false"
      this.previewTarget.src = fileReader.result
      this.previewTarget.classList.remove("d-none")
      this.previewTarget.classList.add("d-flex")
      this.previewPlaceholderTarget.classList.add("d-none")
      this.previewPlaceholderTarget.classList.remove("d-flex")
      if (this.hasTrashTarget) this.trashTarget.classList.remove("d-none")
      if (this.hasTrashTarget) this.trashTarget.classList.add("d-flex")
    }

    if (file) {
      fileReader.readAsDataURL(file)
    } else {
      this.clearFile()
    }
  }

  clearFile() {
    this.fileInputTarget.value = null
    this.hiddenInputDestroyTarget.value = "true"
    this.previewTarget.src = ""
    this.previewTarget.classList.add("d-none")
    this.previewPlaceholderTarget.classList.remove("d-none")
    this.trashTarget.classList.add("d-none")
  }
}
